import React from 'react';
import { motion } from 'framer-motion';
import GiftBox from './GiftBox';

const BoxGrid = ({ boxes, onOpen, openedCount }) => {
  return (
    <div className="grid-screen">
      <motion.div
        className="grid-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="grid-title">Your Gift Boxes 🎁</div>
        <div className="grid-subtitle">
          {openedCount === 0
            ? 'Tap a box to open it! 💙'
            : openedCount === 6
            ? 'All opened! 🎉'
            : `${openedCount} of 6 opened ✨`}
        </div>

        {/* Progress dots */}
        <div className="progress-row">
          {boxes.map((b, i) => (
            <div
              key={b.id}
              className={`progress-dot ${b.opened ? 'done' : ''}`}
            />
          ))}
        </div>
      </motion.div>

      <div className="boxes-grid">
        {boxes.map((box, index) => (
          <GiftBox
            key={box.id}
            box={box}
            index={index}
            onOpen={onOpen}
          />
        ))}
      </div>
    </div>
  );
};

export default BoxGrid;
